/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderFormConfiguration
 */
export interface ProviderFormConfiguration {
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof ProviderFormConfiguration
     */
    suppliers?: Array<GuidIdAndLabel> | null;
}

export function ProviderFormConfigurationFromJSON(json: any): ProviderFormConfiguration {
    return ProviderFormConfigurationFromJSONTyped(json, false);
}

export function ProviderFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function ProviderFormConfigurationToJSON(value?: ProviderFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'suppliers': value.suppliers === undefined ? undefined : (value.suppliers === null ? null : (value.suppliers as Array<any>).map(GuidIdAndLabelToJSON)),
    };
}


